<svelte:options accessors={true} />

<script lang="ts">
  import {getContext} from 'svelte';
  import {CloseButton} from '@components';
  import LockedModal from '../modals/LockedModal.svelte';
  export let forType = '';
  const {open} = getContext('simple-modal');
  $: isDisabled = false;

  function openModal() {
    open(
      LockedModal,
      {forType: forType},
      {
        classWindow: 'relative w-full max-h-full my-2 mx-auto rounded shadow-md bg-white max-w-xl',
        closeOnOuterClick: true,
        closeButton: CloseButton
      },
      {
        onClose: () => {}
      }
    );
  }
</script>

<div class="absolute inset-0 z-40" on:click={openModal} on:keydown={openModal}></div>
<!-- <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="48" height="48" viewBox="0 0 48 48" class="upgrade-modal cursor-pointer" on:click={openModal} on:keydown={openModal}>
    <path fill="#424242" d="M24,4c-5.5,0-10,4.5-10,10v4h4v-4c0-3.3,2.7-6,6-6s6,2.7,6,6v4h4v-4C34,8.5,29.5,4,24,4z"></path><path fill="#FB8C00" d="M36,44H12c-2.2,0-4-1.8-4-4V22c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v18C40,42.2,38.2,44,36,44z"></path><path fill="#C76E00" d="M24 28A3 3 0 1 0 24 34A3 3 0 1 0 24 28Z"></path>
</svg> -->
